import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20elegant%20abstract%20floral%20illustration%20with%20warm%20peach%20coral%20and%20cream%20tones%2C%20minimalist%20feminine%20aesthetic%2C%20flowing%20organic%20shapes%2C%20gentle%20gradient%20background%2C%20clean%20modern%20design%2C%20spa%20wellness%20atmosphere%2C%20soft%20diffused%20lighting%2C%20artistic%20botanical%20elements&width=1600&height=900&seq=hero-main-bg&orientation=landscape"
          alt="女性私密健康"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-4 md:px-6 py-20 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          了解你的身体
          <br />
          <span className="text-primary-300">守护私密健康</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          科学、温暖、不羞耻的女性阴道健康知识平台。
          系统讲解生理结构、日常护理、常见问题及就医建议，
          帮助每一位女性自信面对私密健康。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/changjian-wenti"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white rounded-full font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            开始了解
          </Link>
          <Link
            to="/category/shengli-jiegou"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer"
          >
            探索生理结构
          </Link>
        </div>
      </div>
    </section>
  );
}